import batteriesList from './List'
import batteriesShow from './Show'
import batteriesEdit from './Edit'

const batteriesResource = {
  show: batteriesShow,
  list: batteriesList,
  edit: batteriesEdit,
}

export default batteriesResource
